import React, { Component } from "react";
import CookieBannerConfiguration from "../../models/CookieBannerConfiguration";
import CookieCategory from "../../models/CookieCategory";
import CookieCategoryView from "../views/CookieCategoryView";
import CookieCategoryManagementView from "../views/CookieCategoryManageView";
import Cookies from "universal-cookie";

declare var dataLayer: any;

type CookieBannerPageProps = {
    configuration: CookieBannerConfiguration;
    consentConfigured: () => void;
};

type CookieBannerPageState = {
    enableManagement: boolean;
    categories: CookieCategory[];
};

export default class CookieBannerPage extends Component<CookieBannerPageProps, CookieBannerPageState> {
    constructor(props: CookieBannerPageProps) {
        super(props);
        this.state = {
            enableManagement: false,
            categories: this.props.configuration.cookieCategories,
        };
    }

    public acceptAllCookies(): void {
        this.acceptCookies(true);
    }

    public acceptCookies(acceptAll: boolean = false): void {
        const cookies = new Cookies();

        var domain = ".infino.be";
        if (process.env.NODE_ENV === "development") {
            domain = "localhost";
        }
        cookies.set("cookieConsent", "true", { path: "/", maxAge: 31556926, secure: true, domain: domain }); //MaxAge => Valid for 1 year
        for (let category of this.props.configuration.cookieCategories) {
            if (category.hasConcent || acceptAll) {
                cookies.set(category.cookieName, "true", { path: '/', maxAge: 31556926, secure: true, domain: domain }); //MaxAge => Valid for 1 year
                if (dataLayer) {
                    dataLayer.push({ event: category.cookieName });
                }
            } else {
                cookies.set(category.cookieName, "false", {
                    path: "/",
                    maxAge: 31556926,
                    secure: true,
                    domain: domain
                }); //MaxAge => Valid for 1 year
            }
        }

        let consent = {
            functionality_storage: true,
            security_storage: true,
            analytics_storage: acceptAll,
            ad_storage: acceptAll,
            personalization_storage: acceptAll,
        };

        this.props.configuration.cookieCategories.map((c) => {
            if (c.cookieName === "analytics-cookies" && !acceptAll) {
                consent.analytics_storage = c.hasConcent;
            }

            if (c.cookieName === "marketing-cookies" && !acceptAll) {
                consent.ad_storage = c.hasConcent;
                consent.personalization_storage = c.hasConcent;
            }
        });

        if (dataLayer) {
            dataLayer.push({
                event: "consent_given",
                consent: consent,
            });
        }

        this.props.consentConfigured();

        //refresh page so that other tracking scripts will be activated potentially
        window.location.reload();
    }

    public changeCategoryConsent(category: CookieCategory, accepted: boolean): void {
        category.hasConcent = accepted;

        this.setState({
            categories: [...this.state.categories, category],
        });
    }

    public enableManagement(): void {
        this.setState({
            enableManagement: true,
        });
    }

    public render() {
        return (
            <React.Fragment>
                <section className="container-fluid" id="cookie">
                    <div className="fixed-bottom bg-white rounded m-md-4 px-3 py-4 c-cookiebanner-container">
                        <div className="d-flex flex-wrap flex-column flex-lg-row flex-wrap justify-content-between">
                            <div className="flex-grow-1 w-100 px-2">
                                <p className="text-subtitle mb-2 mb-md-3">{this.props.configuration.title}</p>
                            </div>
                            {!this.state.enableManagement && (
                                <React.Fragment>
                                    {
                                        this.props.configuration.cookieCategories.map((category: CookieCategory, index: number) => {
                                            return <CookieCategoryView cookieCategory={category} key={index}></CookieCategoryView>;
                                        })
                                    }
                                </React.Fragment>
                            )}
                            {this.state.enableManagement && (
                                <fieldset className="flex-grow-1 px-2 d-flex flex-column">
                                    {this.props.configuration.cookieCategories.map((category: CookieCategory, index: number) => {
                                        return (
                                            <CookieCategoryManagementView
                                                index={index}
                                                cookieBannerConfiguration={this.props.configuration}
                                                cookieCategory={category}
                                                key={category.cookieName}
                                                consentChanged={(accepted: boolean) => this.changeCategoryConsent(category, accepted)}>
                                            </CookieCategoryManagementView>
                                        );
                                    })}
                                </fieldset>
                            )}
                            <div className="flex-grow-1 order-md-last w-100 px-2">
                                {!this.state.enableManagement && (
                                    <p
                                        className="pt-2 text-smallest mb-0"
                                        dangerouslySetInnerHTML={{ __html: this.props.configuration.cookieAndPrivacyInformation }}>
                                    </p>
                                )}
                                {this.state.enableManagement && (
                                    <p
                                        className="pt-2 text-smallest mb-0"
                                        dangerouslySetInnerHTML={{ __html: this.props.configuration.additionalInformation }}>
                                    </p>
                                )}
                            </div>
                            <div className="align-content-end align-items-start d-flex flex-column justify-content-center mw-lg-25 px-2 align-items-lg-center">
                                {!this.state.enableManagement && (
                                    <React.Fragment>
                                        <button
                                            type="button"
                                            className="btn btn-primary mt-3 mt-md-3"
                                            onClick={() => this.acceptAllCookies()}>
                                            {this.props.configuration.acceptButtonText}
                                        </button>
                                        <button
                                            className="btn btn-link text-secondary link-chevron d-block pt-2 text-small"
                                            onClick={() => this.enableManagement()}>
                                            {this.props.configuration.otherSettingsButtonText}
                                        </button>
                                    </React.Fragment>
                                )}
                                {this.state.enableManagement && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary mt-3 mt-md-3"
                                        onClick={() => this.acceptCookies()}>
                                        {this.props.configuration.acceptOtherSettingsButtonText}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}
